import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Types
export interface ExcelRow {
  [key: string]: string | number | boolean | null;
}

interface THandleDownloadSampleFormate {
  columns: string[];
  fileName?: string;
}

export const useSampleFile = () => {
  const handleDownloadSampleFormate = ({
    columns,
    fileName = "export",
  }: THandleDownloadSampleFormate) => {
    const sampleRow: Record<string, string> = {};

    columns.forEach((c) => {
      sampleRow[c] = ""; // keep all columns
    });

    const worksheet = XLSX.utils.json_to_sheet([sampleRow]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  return {
    handleDownloadSampleFormate,
  };
};
